var map = {
	"./01.mp3": 82,
	"./02.mp3": 83,
	"./03.mp3": 84,
	"./04.mp3": 85,
	"./05.mp3": 86,
	"./05_1.mp3": 87,
	"./06.mp3": 88,
	"./07.mp3": 89,
	"./bp.mp3": 90,
	"./check.mp3": 91,
	"./error.mp3": 92,
	"./id.mp3": 93,
	"./weight.mp3": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;